import { useMutation, useQuery, useQueryClient } from "react-query";
import { AxiosInstance } from "../axios.config";
import { api } from "../constants";
import { ICouponListResponse } from "./types";
import { ICreateCouponData } from "@/pages/VoucherManagement/CreateCouponForm";

export interface IGetCouponParams {
  status?: string;
  page?: number;
  start_date?: string;
  end_date?: string;
  query?: string;
}

const getCouponList = async (
  params: IGetCouponParams
): Promise<ICouponListResponse> => {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value != null && value !== "")
  );
  const response = await AxiosInstance.get<ICouponListResponse>(
    api.coupon.list,
    {
      params: filteredParams,
    }
  );
  return response.data;
};

const useGetCouponList = (params: IGetCouponParams) => {
  return useQuery<ICouponListResponse>({
    queryKey: ["coupon-list"],
    queryFn: () => getCouponList(params),
  });
};

const createCoupon = (data: ICreateCouponData) => {
  const { coupon_type, ...payload } = data;
  return AxiosInstance.post(api.coupon.create, payload);
};

const useCreateCouponMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: "create-coupon",
    mutationFn: createCoupon,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["coupon-list"] });
    },
  });
};

const deleteCoupon = (id: string) => {
  return AxiosInstance.delete(api.coupon.delete.replace(":id", id));
};

const useDeleteCouponMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: "delete-coupon",
    mutationFn: deleteCoupon,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["coupon-list"] });
    },
  });
};

export { useGetCouponList, useCreateCouponMutation, useDeleteCouponMutation };
